<script lang="ts">
    import {Component, Prop, Watch, Vue, toNative} from 'vue-facing-decorator'
    import HotelMap from '~/components/search/offers/HotelMap.vue'

    @Component({mixins: [HotelMap]})
    export class CruiseMap extends Vue {
        @Prop() points
        @Prop({default: null}) parent

        markers = []
        cruisePath = null
        directionsDisplay = null

        @Watch('points', {immediate: false, deep: true})
        onPointsChange() {
            if (!this.map) return
            this.setMarkers()
        }

        async load() {
            await this.initMap()
            await this.setMarkers()
        }

        async setMarkers() {
            this.removeMarkers()
            let points = [...this.points]

            // this.makeDirection(points)
            const templateColor = this.$vuetify.theme.themes.light.colors.primary

            const markerIcon = {
                path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
                fillColor: templateColor,
                fillOpacity: 0.95,
                scale: 2,
                strokeColor: '#fff',
                strokeWeight: 3,
                anchor: new this.google.maps.Point(12, 24),
            }
            points.forEach(point => {
                const marker = new this.google.maps.Marker({
                    position: {
                        lat: point.latitude,
                        lng: point.longitude,
                    },
                    map: this.map,
                    icon: markerIcon,
                    info: point,
                })
                this.markers.push(marker)
            })
            this.bounds = new this.google.maps.LatLngBounds()
            this.markers.forEach(marker => this.bounds.extend(marker.getPosition()))
            if (
                this.points.length === 2 &&
                this.points[0].latitude === this.points[1].latitude &&
                this.points[0].longitude === this.points[1].longitude
            ) {
                this.map?.setZoom(12)
                this.map?.setCenter({lat: this.points[0].latitude, lng: this.points[0].longitude})
            } else {
                this.map.fitBounds(this.bounds)
            }
        }

        removeMarkers() {
            this.markers.forEach(marker => toRaw(marker).setMap(null))
            if (this.markerCluster) {
                toRaw(this.markerCluster).clearMarkers()
            }
            this.markers = []
            if (this.cruisePath) {
                this.cruisePath.setMap(null)
            }
        }

        getMapOptions() {
            return {
                disableDefaultUI: true,
                gestureHandling: 'greedy',
                mapTypeControl: true,
                zoomControl: true,
                fullscreenControl: true,
                zoom: 8,
            }
        }

        yPos() {
            const y = !this.isMobile
                ? this.$parent.$parent.$el.parentElement.getBoundingClientRect().y
                : this.getMobileYPosition()
            return y > 0 ? y : 0
        }

        getMobileYPosition() {
            return !this.parent ? this.$parent.$refs.mobileTabs?.$el?.offsetHeight : 0
        }

        saveMapPosition() {}
    }

    export default {...toNative(CruiseMap), ssrRender: HotelMap.ssrRender}
</script>

<style scoped lang="scss">
    @use 'vuetify/settings';
    @use 'sass:map';

    .map {
        position: fixed;

        @media #{map.get(settings.$display-breakpoints, 'xs')} {
            margin-left: -(settings.$container-padding-x);
        }

        > div {
            height: 100%;
        }
    }
</style>
